// The words the free read says when a visitor arrives from a college page
// (#2608). `short` is the school's short name from its college data file
// (NYU); `name` its full name.

// A test-blind school's visitor is never asked for scores (#3262, product
// invariant 4): `testBlind` comes from the college page's testing.blind, or
// from the server's personal-read offer (personalize.test_blind).

// TryHero: replaces the line under the heading.
export const tryHeroSchoolLine = (short, testBlind = false) => (testBlind
    ? `Let's see where you stand at ${short}. Tell us your grades and what you do outside class. ${short} doesn't consider test scores.`
    : `Let's see where you stand at ${short}. Tell us your grades, test scores and what you do outside class.`);

// The pre-set school shown in the box before the picture.
export const schoolChipLabel = 'School';

// Astra Lite: the greeting, with the school in place of "any school".
export const astraSchoolGreeting = (short, testBlind = false) => (testBlind
    ? `Hi, I'm Astra. Tell me your grades and what you do outside class, and I'll show you where you stand at ${short}. ${short} doesn't consider test scores, so leave them out. Type it or say it.`
    : `Hi, I'm Astra. Tell me your grades, test scores and what you do outside class, and I'll show you where you stand at ${short}. Type it or say it.`);

// Astra Lite: the line over the picture once the school's read is on its way.
// While the GPA ask is open, no read is on its way yet, so the line promises
// none.
export const astraSchoolUnderstood = (short, gated = false) => (gated
    ? "Here's what I understood."
    : `Here's what I understood. Here's where you stand at ${short}, and you can check any other school too.`);
